import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import { setBs4Snackbar } from './Bs4Snackbar.js';
import { useSnackbar } from 'notistack'

import Bs4MainDispatch from './Bs4MainDispatch';

import Bs4AppBar from './Bs4AppBar/Bs4AppBar';
import Bs4HorizontalMenu from './Bs4Menu/Bs4HorizontalMenu';
import Bs4VerticalMenu from './Bs4Menu/Bs4VerticalMenu';
import Bs4Kartoteka from './Bs4Kartoteka';
import Bs4LoginNew from './Bs4Login';
import Bs4LoginOld from './Bs4Login2024-07-08';
import Bs4SessionExpired from './Bs4SessionExpired';
import { bs4RunSnackbar, bs4CloseSnackbar } from './Bs4Snackbar.js';
import Bs4I18N from './Bs4I18N';
import Bs4ShowRequest from './Bs4Components/Bs4ShowRequest'
import Bs4NewTab from './Bs4NewTab';
import {isNullOrNaN, shallowEqual} from './Bs4Components/Bs4Utils';

import { Bs4UxTemplates, getUxTemplate, UxAccordion, SmallScreenContext, useStateUxTemplate } from './Bs4Theme/Bs4UxTemplates';
import { Bs4ReportCalendarPlanningUx } from './Bs4Theme/Bs4UxTemplateEditors/Bs4MainWindowUx.js'

import bs4NotificationsFCM from './Bs4NotificationsFCM.js';
import { setHideTopMenuForMobile } from './Bs4Components/HideOnScroll';

Bs4Kartoteka.clear();
new Bs4AppBar();

export const SECOND = 1000;
export const SESSIONTIMESEC = 'sessionTimeSec';
export const SESSION_LOGGED = 'session_logged';
export const SESSION_EXPIRED = 'session_expired';
export const SESSION_EXPIRED_MESSAGE = 'session_expired_message';

export const EXTERNAL_OPTION_ID = 'ExternalOptionId'
export const WINDOW_OBJECT_ID = 'windowObjectId'
export const SUM = 'sum'
export const BS4UXTEMPLATES = 'Bs4UxTemplates'
export const BS4UXTEMPLATES_UXMAINID = 'Bs4UxTemplates_uxMainId'
export const INFO_BS4_MESSAGE = 'infoBs4Message';
export const BS4_SHOW_INFO_MSG = 'bs4ShowInfoMsg';
export const LAST_SESSION_ACTIVITY = 'lastSessionActivity';
export const TYPE_BS4_THEME = 'type_bs4_theme';
export const TYPE_APPBAR = 'type_AppBar';
export const TYPE_INCOMING = 'type_Incoming';
export const TYPE_VERTICALMENU = 'type_VerticalMenu'
export const TYPE_VERTICALMENU_OPTIONS = 'type_VerticalMenu_options'
export const TYPE_A_LINK = 'type_a_link'
export const MOBILEHASH = 'mobilehash';
export const CONNECTIONID = 'connectionid';

export default class Bs4MainWindow {    

  static get BS4LAUNCHMAINPAGE () {return 'Bs4LaunchMainPage'}
  
  static instance = null;

  static newBs4Kartoteka(message, lastCommandParserAfterRow, toBeContinue) {
    Bs4MainWindow.instance.newBs4Kartoteka(message, lastCommandParserAfterRow, toBeContinue);
  }

  static removeBs4Kartoteka(bs4KartotekaId) {
    Bs4MainWindow.instance.removeBs4Kartoteka(bs4KartotekaId);
  }

  static showStack(toBeContinue) {
    Bs4MainWindow.instance.showStack(toBeContinue);
  }

  static mainPageDetails = null;

  constructor() {    
    console.log('...Main Window constructor...', window.location, window.location.href);    
    console.log('...Main Window constructor.1.', navigator.userAgent, navigator.userAgent.includes("Chrome"));    
    
    if (Bs4MainWindow.instance) {
      throw new Error("Singleton (Bs4MainWindow) classes can't be instantiated more than once.")
    }

    Bs4MainDispatch.setCurrentDomain(false);
    
    Bs4I18N.restoreToPhrase();
     
    Bs4MainWindow.instance = this;
    this.startSessionInActivity();

    try {
      this.bs4ExternalLink = JSON.parse(window.localStorage.getItem('bs4ExternalLink'));
      // console.log('...bs4ExternalLink.c.', {...this.bs4ExternalLink});
    } catch(error) {
      delete this.bs4ExternalLink;
    }
    window.localStorage.removeItem('bs4ExternalLink');

    // zewnetrzne linki z push
    const urlParams = new URLSearchParams(window.location.search);
    Bs4MainDispatch.additionalget = {};
    for (const [key, value] of urlParams.entries()) {
      Bs4MainDispatch.additionalget[key] = value;Bs4I18N.getLang()
      //console.log('...URLSearchParams...', key, value, Bs4MainDispatch.additionalget);
    }
    // console.log('...URL.SEARCH...', urlParams, Bs4MainDispatch.additionalget)
    if (urlParams?.get(EXTERNAL_OPTION_ID) && urlParams?.get(WINDOW_OBJECT_ID) && urlParams?.get(SUM)) {
      //Powiadomienie zapamiętane, będzie uruchomione po poprawnym zalogowaniu i renderowaniu pierwszej strony
      this.bs4ExternalNotification = urlParams
    }

    console.log('...URL.SEARCH...', urlParams, Bs4MainDispatch.additionalget)    

    const msgId = urlParams?.get(INFO_BS4_MESSAGE);
    // console.log('....msg id...', msgId, window.location);    
    if (msgId) {
      Bs4MainDispatch.commandParser(BS4_SHOW_INFO_MSG, {msgId: msgId}, null);
      //window.history.replaceState(null, '', window.location.pathname);
      //window.history.pushState({}, document.title, '/' + '');
    }

    // window.addEventListener("beforeunload", (event) => {
    //   event.preventDefault()
    //   event.returnValue = '';
    //   alert("hello bs4");
    // });
 
    window.addEventListener('storage', event => {
      // console.log('...window event storage ', event.key, event.newValue)
      if (event.key === SESSION_LOGGED) {
        if (event.newValue) {
          // Ok.
        } else {
          //Wylogowanie - zamknięcie okna - zakładki.
          //Ekran logowania pozostaje tylko w tej zakładce, która wykonała 'sessionKillAll(...)'
          window.close();
        }
      }
		});     

    window.addEventListener('load', async () => {
      window.addEventListener('online', () => this.setOnline(true));  
      window.addEventListener('offline', () => this.setOnline(false));
    });    

    this.bs4MainWindowUx = new Bs4ReportCalendarPlanningUx();
    
    try {
      Bs4UxTemplates.setUxTemplates(JSON.parse(window.localStorage.getItem(BS4UXTEMPLATES)), window.localStorage.getItem(BS4UXTEMPLATES_UXMAINID))
      // this.setUxTemplate();
      this.bs4MainWindowUx.setUxTemplate();
    } catch(error) {
      Bs4UxTemplates.setUxTemplates(null, null);
      // this.setUxTemplate();
      this.bs4MainWindowUx.setUxTemplate();
    }    

    document.mobileBs4 = {};
    document.mobileBs4.sendToServer = (cmd, details) => {
      console.log('...document.mobileBs4.sendToServer...', cmd, details);
      Bs4MainDispatch.commandParser(cmd, JSON.parse(details), this.bs4KartotekaId);
    }

    document.mobileBs4.parsingBs4Response = (response64) => {
      console.log('...document.mobileBs4.parsingBs4Response.1.', response64);
      try {
        const responseStr = atob(response64);
        console.log('...document.mobileBs4.parsingBs4Response.1.', responseStr);
        const responseJson = JSON.parse(responseStr);
        console.log('...document.mobileBs4.parsingBs4Response.2.', responseJson);
        Bs4MainDispatch.parsingBs4Response(responseJson, null);
      } catch(error) {
        console.log('...document.mobileBs4.parsingBs4Response...ERROR', error);
      }      
    }

    console.log('...MOBILE...document.mobileBs4.', document.mobileBs4, 'buildDate:', Bs4MainWindow.buildDate);

    // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);    
    // console.log('...MOBILE...', isMobile, navigator.userAgent);
  }

  bs4RunSnackbarId = null;

  setOnline = (online) => {
    if (online && this.bs4RunSnackbarId) {
      bs4CloseSnackbar(this.bs4RunSnackbarId);
      this.bs4RunSnackbarId = null;
      const text_Server_available = Bs4I18N.getTT("Server available", 'Serwer dostępny', 'Bs4AppBar');
      bs4RunSnackbar(text_Server_available, 0, );
    }
    if (!online && ! this.bs4RunSnackbarId) {
      const text_Server_not_responding = Bs4I18N.getTT("The server is not responding. Check your internet connection.", 'Serwer nie odpowiada. Sprawdź połączenie z internetem.', 'Bs4AppBar');
      this.bs4RunSnackbarId = bs4RunSnackbar(text_Server_not_responding, 21, );
    }
  }

  bs4KartotekaId = null;

  startSessionInActivity = () => {		
		document.addEventListener("scroll",     () => this.setLastSessionActivity(), true);
		document.addEventListener("mousedown",  () => this.setLastSessionActivity(), true);
		document.addEventListener("keydown",    () => this.setLastSessionActivity(), true);		
		document.addEventListener("touchstart", () => this.setLastSessionActivity(), true);
		document.addEventListener("mousemove",	() => this.setLastSessionActivity(), true);		
		this.startTaskCheckSessionExpired();
	}
	
  startTaskCheckSessionExpired = () => {
    // test // window.localStorage.setItem(SESSIONTIMESEC, '10');
    this.checkSessionExpired();
    let sessionTimeSec = parseInt(window.localStorage.getItem(SESSIONTIMESEC));
    if (isNullOrNaN(sessionTimeSec) || sessionTimeSec === 0) sessionTimeSec = 60; //Pętla musi działć zawsze.
    setTimeout(this.startTaskCheckSessionExpired, 1000 * sessionTimeSec);    
  }

	checkSessionExpired = () => {
		const sessionInactivitySec = (Date.now() - this.getLastSessionActivity()) / SECOND;
    if (sessionInactivitySec < 10) return;
    const sessionTimeSec = parseInt(window.localStorage.getItem(SESSIONTIMESEC));
    // console.log('...checkSessionExpired.1.', sessionInactivitySec, sessionTimeSec, window.localStorage.getItem(SESSION_EXPIRED), sessionInactivitySec > sessionTimeSec);
    // console.log('...checkSessionExpired.2.', (!window.localStorage.getItem(SESSION_EXPIRED) && sessionInactivitySec > sessionTimeSec));    
    if (isNullOrNaN(sessionTimeSec) || sessionTimeSec === 0) return;
		if (!window.localStorage.getItem(SESSION_EXPIRED) && sessionInactivitySec > sessionTimeSec) {      
      Bs4MainDispatch.commandParser('Bs4NoActivity', {}, this.bs4KartotekaId);
		}    
	}
	
	getLastSessionActivity = () => window.localStorage.getItem(LAST_SESSION_ACTIVITY);
	setLastSessionActivity = () => {}

  notification(bs4Kartotekaid) {
    if (this.bs4ExternalNotification) {
      if (this.bs4ExternalNotification?.get(EXTERNAL_OPTION_ID) && this.bs4ExternalNotification?.get(WINDOW_OBJECT_ID) && this.bs4ExternalNotification?.get(SUM)) {
        Bs4MainDispatch.commandParser('Bs4OpenCard', {
          targetOption: this.bs4ExternalNotification.get(EXTERNAL_OPTION_ID), 
          targetObject: this.bs4ExternalNotification.get(WINDOW_OBJECT_ID), 
          linksum: this.bs4ExternalNotification.get(SUM)
        }, bs4Kartotekaid);
        this.bs4ExternalNotification = new URLSearchParams('');        
      }
      return true;
    }
		return false
	}

	notificationNow(payload) {
		if (!window.localStorage.getItem(SESSION_LOGGED)) return false;
		if (!payload?.notification?.click_action) return false;
		const [url, search]  = payload.notification.click_action.split('?')
		if (!search) return false;
		this.bs4ExternalNotification = new URLSearchParams(search)
		return this.notification(null);
	}

	notificationAfter(bs4Kartotekaid) {		
    if (!window.localStorage.getItem(SESSION_LOGGED)) return false;
		if (!this.bs4ExternalNotification) return false;
		return this.notification(bs4Kartotekaid);
	}

  handleMenuClick = (item) => {
    // console.log('...menu click item...', item);
    const next = Bs4Kartoteka.getNext(Bs4Kartoteka.firstBs4KartotekaId);
    if (next) {
      Bs4Kartoteka.remove(next.bs4KartotekaId)
      .then((msg) => {
        this.showStack();
        this.onMenuClickCanClose(item);        
      })
      .catch((msgt) => {
        console.log('...onMenuClick..catch...', msgt);
        this.showStack();
      });
    } else {
      this.onMenuClickCanClose(item);
    }
  }

  onMenuClickCanClose = (item) => {
    const bs4Kartoteka = Bs4Kartoteka.get(Bs4Kartoteka.firstBs4KartotekaId)
    bs4Kartoteka.handleMenuClick(item);
  }

  sessionExpiredMessage = (message) => {}

  bs4ShowRequestArray = [];

  mobileBs4GetBase64FromBlobData = (blobUrl, filename, type) => {          
    const mainWindow = this;
    const xhr = new XMLHttpRequest();  
    xhr.open('GET', blobUrl, true);
    xhr.setRequestHeader('Content-type', type);
    xhr.responseType = 'blob';
    xhr.onload = function(e) {
      if (this.status == 200) {
        const blobData = this.response;        
        const reader = new FileReader();
        reader.readAsDataURL(blobData);
        reader.onloadend = function() {
          const base64data = reader.result.split(',', 2)[1];
          URL.revokeObjectURL(blobUrl);
          const androidBs4 = Bs4MainDispatch.getAndroidBs4();          
          if (androidBs4?.downloadBase64FileBs4) {
            const ok = androidBs4.downloadBase64FileBs4(base64data, blobData.type, filename);
          }
          const appleBs4 = Bs4MainDispatch.getAppleBs4();
          if (appleBs4?.downloadBase64FileBs4) {
            appleBs4.downloadBase64FileBs4.postMessage({
              base64data: base64data,
              type: blobData.type,
              filename: filename
            });
          }
        }
      }
    };
    xhr.send();
  }

  setBackgroundPicture = (message, setUxTemplateUpdate) => {
    const f = () => {      
      this.bs4MainWindowUx.setUxTemplate(message?._Komunikat?.uxMainId);
      setUxTemplateUpdate( null, this.bs4MainWindowUx.uxTemplate);
    }

    if (message._Komunikat?.backgroundPicture) {
      const link = Bs4MainDispatch.getUrlPath(message._Komunikat?.backgroundPicture);    
      fetch(link)
      .then(res => res.blob())
      .then(blob => {
        const objectURL = URL.createObjectURL(blob);
        console.log('...setUxTemplateUpdateMain fetch...', objectURL)  
        this.bs4MainWindowUx.defaultUxTemplate.body.Main.theme.backgroundPicture = {
          backgroundImage: 'url("'+objectURL+'")',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
        f();
      })
      .catch(error => {
        console.log('...openNewDownload fetch...', error)  
      }) 
    } else {
      f();
    }    
  };

  timeoutForOpenNew = 0;

  shallowEqual01 = null;
  shallowEqualProps01 = null;

  ViewComponent = (props) => {
    const thisMain = this;
    const theme = useTheme();
    const {dateTimeStamp, setUxTemplateUpdate} = useStateUxTemplate(TYPE_BS4_THEME);
    const smallScreen = React.useContext(SmallScreenContext);
    this.smallScreen = smallScreen;
    const uxTemplate = React.useMemo(() => {
      if (smallScreen) {
        delete this.bs4MainWindowUx.uxTemplate?.body?.AppBar?.box?.height;
        delete this.bs4MainWindowUx.uxTemplate?.body?.AppBar?.box?.margin;
        delete this.bs4MainWindowUx.uxTemplate?.body?.AppBar?.box?.padding;
      }            
      return {};
    }, [dateTimeStamp, smallScreen])

    const bs4UseSnackbar = useSnackbar()
    setBs4Snackbar(bs4UseSnackbar)
  
    // const [login, setLogin] = React.useState(false);
    const [loginMessage, setLoginMessage] = React.useState(null);    
    const [sessionExpired, setSessionExpired] = React.useState(false);
    const [askCodeStep2, setAskCodeStep2] = React.useState(null);
    const [bs4ShowRequest, setBs4ShowRequest] = React.useState(null);    
    const [toBeContinue, setToBeContinue] = React.useState(null);
    const [showStack, setShowStack] = React.useState([]);
    const lastBs4Kartoteka = React.useMemo(() => {
      if (!Array.isArray(showStack)) return null;      
      return showStack.at(-1);
    }, [showStack]);
    const [mainPageDetails, setMainPageDetails] = React.useState(null);
    const [mainMenu, setMainMenu] = React.useState(null);
    const [MenuIconButton, setMenuIconButton] = React.useState(<span/>);
    const [miniLeftMenu, setMiniLeftMenu] = React.useState(false);

    const [linkNewTab, setLinkNewTab] = React.useState(null);        

    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {
        theme,
        dateTimeStamp,
        smallScreen,
        uxTemplate,
        bs4UseSnackbar,
        loginMessage,
        sessionExpired,
        askCodeStep2,
        bs4ShowRequest,
        toBeContinue,
        showStack,
        lastBs4Kartoteka,
        mainPageDetails,
        mainMenu, 
        MenuIconButton,
        miniLeftMenu,
        linkNewTab,
      };
      console.log(Bs4MainDispatch.speedStartTime(tag), shallowEqual(newObj, this.shallowEqual01, Bs4MainDispatch.speedPrefix+tag+' EqualValue'), shallowEqual(props, this.shallowEqualProps01, Bs4MainDispatch.speedPrefix+tag+' EqualProps'));
      this.shallowEqual01 = newObj;
      this.shallowEqualProps01 = props;
    }, 'Main');        

    this.setMiniLeftMenu = (mini) => {
      // console.log(new Error('...miniLeftMenu...mini:'), mini, miniLeftMenu)
      if (mini !== miniLeftMenu) setMiniLeftMenu(mini);
    }

    const bs4LaunchMainPage = () => {      
      if (this.notificationAfter(null)) {
      } else if (this.bs4ExternalLink?.mainPageDetails) {
        Bs4MainDispatch.parsingBs4ResponseMessagges([this.bs4ExternalLink?.mainPageDetails], null)
      } else if (this.bs4ExternalLink?.cardData) {
        const messages = [this.bs4ExternalLink.cardData]
        if (Array.isArray(this.bs4ExternalLink?.toBeContinue?.messages)) messages.push(...this.bs4ExternalLink.toBeContinue.messages)
        Bs4MainDispatch.parsingBs4ResponseMessagges(messages, null)
      } else {
        this.clear();
        Bs4MainDispatch.commandParser(Bs4MainWindow.BS4LAUNCHMAINPAGE, {liteInterface: smallScreen ? 1 : 0, locale: Bs4I18N.getLang()}, null);         
      }
    }

    React.useEffect(() => {    
      const setSessionExpiredNaw = (expired) => {
        if (sessionExpired !== expired) {
          setSessionExpired(expired);
        }      
      }

      this.setLastSessionActivity = () => {
        window.localStorage.setItem(LAST_SESSION_ACTIVITY, Date.now());
        if (Boolean(window.localStorage.getItem(SESSION_EXPIRED))) {
          window.localStorage.removeItem(SESSION_EXPIRED);
        }
        setSessionExpiredNaw(false);
      }

      this.sessionExpiredMessage = (message) => {
        if (!Boolean(message?._Komunikat)) return;
        // console.log('...window event storage sessionExpiredMessage', message, Boolean(message?._Komunikat));
        if (message?._Komunikat) window.localStorage.setItem(SESSION_EXPIRED_MESSAGE, message._Komunikat);
        window.localStorage.setItem(SESSION_EXPIRED, 1);
        setSessionExpiredNaw(true);
      }

      const eventSessionExpired = (event) => {
        if (event.key !== SESSION_EXPIRED) return;
        // console.log('...Bs4SessionExpired SESSION_EXPIRED', event.key, event.newValue)
        setSessionExpiredNaw(Boolean(event.newValue));
      }
      window.addEventListener('storage', eventSessionExpired);
  
      return () => window.removeEventListener('storage', eventSessionExpired);
    }, [sessionExpired, setSessionExpired]);

    React.useEffect(() => {
      this.setLinkNewTab = setLinkNewTab;
    }, [setLinkNewTab]);    

    React.useEffect(() => {      
      this.showBs4Request = (message) => {
        const newBs4ShowRequest = message?._Komunikat;
        if (this.bs4ShowRequestArray.length === 0) setBs4ShowRequest(newBs4ShowRequest);
        if (newBs4ShowRequest) this.bs4ShowRequestArray.push(newBs4ShowRequest);
      }

      if (!bs4ShowRequest) setBs4ShowRequest(this.bs4ShowRequestArray.shift())

      return () => { 
        if (bs4ShowRequest) this.bs4ShowRequestArray = this.bs4ShowRequestArray.filter(bsr => bsr !== bs4ShowRequest);
      };
    }, [bs4ShowRequest, setBs4ShowRequest]);


    React.useEffect(() => {
      this.setOnline(window.navigator.onLine);

      // this.setLogin = setLogin;
      this.setLoginMessage = setLoginMessage;

      this.setAskCodeStep2 = (message) => {
        setAskCodeStep2(message?._Komunikat || null);
      }

      ///////////////// interface for Bs4MainDispatch ///////////// begin      

      this.clear = () => {        
        Bs4Kartoteka.clear();
        setShowStack([])
        setMainPageDetails(null);
        setMainMenu(null);
        Bs4MainDispatch.setStartTime();
      }

      this.afterLogin = (message) => {
        window.localStorage.setItem(SESSION_LOGGED, true)
        // this.setLogin(false);
        this.setLoginMessage(null);
        // this.sessionExpired(false);
        const currentUser = window.localStorage.getItem(SESSION_EXPIRED_MESSAGE);
        if (Boolean(currentUser)) return;
        bs4LaunchMainPage();
      }

      this.openNewTab = (message) => {        
        const link = Bs4MainDispatch.getUrlPath(message._Komunikat.toString()); 
        // console.log('...Main...openNewTab.0.', message._Komunikat)
        // console.log('...Main...openNewTab.1.', link)
        // if (Bs4MainDispatch.getMobile()) this.setLinkNewTab(link);
        // else window.open(link);     
        const isAndroid = /Android/i.test(navigator.userAgent);
        if (message._Typ === 'OPEN_NEW_TAB_URL' && link.startsWith('https://meet.google.com/') && isAndroid) {
          window.open(link);
          return;
        }
        if (this.smallScreen) this.setLinkNewTab(link); else {
          this.timeoutForOpenNew += 5000;
          setTimeout(() => {
            console.log('...Main...openNewTab???????', link)
            window.open(link);
            this.timeoutForOpenNew -= 5000;
          }, 0)          
        }
      }

      this.openNewDownload = (message) => {
        const link = Bs4MainDispatch.getUrlPath(message._Komunikat.url);      
        if (parseInt(message._Komunikat?.remote) === 1) {
          const url = message._Komunikat.url    
          const appleBs4 = Bs4MainDispatch.getAppleBs4()
          if (appleBs4) window.open(url, '_self').focus();
          else window.open(url, '_blank').focus(); 
          return;
        }

        fetch(link)
        .then(res => res.blob()) // Gets the response and returns it as a blob
        .then(blob => {
            let objectURL = URL.createObjectURL(blob);
            if (Bs4MainDispatch.getAndroidBs4() || Bs4MainDispatch.getAppleBs4())  {
              this.mobileBs4GetBase64FromBlobData(objectURL, message._Komunikat.filename, blob.type);
            } else {
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = objectURL;
              a.download =  message._Komunikat.filename;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(objectURL);              
              a.remove();
            }            
        })
        .catch(error => {
          console.log('...openNewDownload fetch...', error)  
        }) 
      };

      this.sessionKillAll = (message) => {
        console.log('... sessionKillAll ...', message)
        Bs4MainDispatch.setCurrentDomain(false);
        window.localStorage.removeItem(SESSION_EXPIRED_MESSAGE);
        if (window.localStorage.getItem(SESSION_LOGGED)) {
          window.localStorage.removeItem(SESSION_LOGGED);
          window.location.reload();
          return;
        }

        window.localStorage.removeItem(SESSION_LOGGED);
        this.clear();
        // this.setLogin(message);
        this.setLoginMessage(message._Komunikat);        
      }      
  
      this.newMainPageDetails = (message) => {
        this.clear();
        Bs4UxTemplates.setUxTemplates(message?._Komunikat?.uxTemplates, message?._Komunikat?.uxMainId);
        Bs4MainDispatch.setCurrentDomain(true);
        setHideTopMenuForMobile(Boolean(parseInt(message?._Komunikat?.hideTopMenuForMobile) === 1));
        setMainPageDetails(message);        

        window.localStorage.setItem(BS4UXTEMPLATES, JSON.stringify(message?._Komunikat?.uxTemplates));
        window.localStorage.setItem(BS4UXTEMPLATES_UXMAINID, message?._Komunikat?.uxMainId);      
        window.localStorage.setItem('fronttest', message?._Komunikat?.fronttest);
        window.localStorage.setItem('varianticCloudLibrary', message?._Komunikat?.varianticCloudLibrary);

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
       ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
     ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //  window.localStorage.setItem('fronttest', 0);    ///////////////////////////////////////////////////////////
    // if (window.location.host === "localhost:3000") window.localStorage.setItem('fronttest', 99);
    // if (window.location.host === "localhost") window.localStorage.setItem('fronttest', 99);
   ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
 ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
       
        // message._Komunikat.backgroundPicture = 'showp.php?previewid=5029188-84ca3d18954f0a5d041c0d46e57729c0';        
        this.setBackgroundPicture(message, setUxTemplateUpdate);
        
        Bs4MainWindow.mainPageDetails = message;
        window.localStorage.setItem(SESSIONTIMESEC, message?._Komunikat?.session_time_sec);
        //console.log('.....checkSessionExpired..getItem..', window.localStorage.getItem(SESSIONTIMESEC), message);
        if (this.bs4ExternalLink?.mainPageDetails && this.bs4ExternalLink?.cardData) {
          // console.log('...bs4ExternalLink.2.', {...this.bs4ExternalLink});
          Bs4MainDispatch.parsingBs4ResponseMessagges([this.bs4ExternalLink.cardData], null);
        } else {
          // Bs4MainDispatch.commandParser('Bs4OpenCard', {
          //   targetOption: message._Komunikat.defaultStartPage, 
          //   currCardViewId: null
          // }, Bs4MainWindow.BS4LAUNCHMAINPAGE);
        }

        // try {
        //   // const responseStr = '{"idSourceCardView":null,"messgs":[{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"bs4userMobile\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"token\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"phone_number\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":0,"_Komunikat":"","_IdBs4Source":null,"_start":""},{"_Typ":2,"_Komunikat":"3 wyst\u0105pie\u0144 PHP Warning\/Notice. Zobacz debugger.","_IdBs4Source":null,"_start":""}]}';
        //   const responseStr = `{"idSourceCardView":null,"messgs":[{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"bs4userMobile\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"token\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":1,"_Komunikat":"bs4 Warning: Undefined array key \"phone_number\" in \/var\/www\/html\/bs4core\/jw2\/mobile.php on line 20","_IdBs4Source":null,"_start":""},{"_Typ":0,"_Komunikat":"","_IdBs4Source":null,"_start":""},{"_Typ":2,"_Komunikat":"3 wystąpień PHP Warning\/Notice. Zobacz debugger.","_IdBs4Source":null,"_start":""}]}`;                               
        //   const response64 = 'eyJpZFNvdXJjZUNhcmRWaWV3IjpudWxsLCJtZXNzZ3MiOlt7Il9UeXAiOjEsIl9Lb211bmlrYXQiOiJiczQgV2FybmluZzogVW5kZWZpbmVkIGFycmF5IGtleSBcImJzNHVzZXJNb2JpbGVcIiBpbiBcL3Zhclwvd3d3XC9odG1sXC9iczRjb3JlXC9qdzJcL21vYmlsZS5waHAgb24gbGluZSAyMCIsIl9JZEJzNFNvdXJjZSI6bnVsbCwiX3N0YXJ0IjoiIn0seyJfVHlwIjoxLCJfS29tdW5pa2F0IjoiYnM0IFdhcm5pbmc6IFVuZGVmaW5lZCBhcnJheSBrZXkgXCJ0b2tlblwiIGluIFwvdmFyXC93d3dcL2h0bWxcL2JzNGNvcmVcL2p3MlwvbW9iaWxlLnBocCBvbiBsaW5lIDIwIiwiX0lkQnM0U291cmNlIjpudWxsLCJfc3RhcnQiOiIifSx7Il9UeXAiOjEsIl9Lb211bmlrYXQiOiJiczQgV2FybmluZzogVW5kZWZpbmVkIGFycmF5IGtleSBcInBob25lX251bWJlclwiIGluIFwvdmFyXC93d3dcL2h0bWxcL2JzNGNvcmVcL2p3MlwvbW9iaWxlLnBocCBvbiBsaW5lIDIwIiwiX0lkQnM0U291cmNlIjpudWxsLCJfc3RhcnQiOiIifSx7Il9UeXAiOjAsIl9Lb211bmlrYXQiOiIiLCJfSWRCczRTb3VyY2UiOm51bGwsIl9zdGFydCI6IiJ9LHsiX1R5cCI6MiwiX0tvbXVuaWthdCI6IjMgd3lzdMSFcGllxYQgUEhQIFdhcm5pbmdcL05vdGljZS4gWm9iYWN6IGRlYnVnZ2VyLiIsIl9JZEJzNFNvdXJjZSI6bnVsbCwiX3N0YXJ0IjoiIn1dfQ=='
        //   // const responseSttt = fromBinary(response64);
        //   const responseSttt = atob(response64);
        //   console.log('...document.mobileBs4.parsingBs4Response.1.', responseStr);
        //   console.log('...document.mobileBs4.parsingBs4Response.1.', responseSttt);
        //   const responseJson = JSON.parse(responseSttt);
        //   console.log('...document.mobileBs4.parsingBs4Response.2.', responseJson);
        //   Bs4MainDispatch.parsingBs4Response(responseJson, null);
        // } catch(error) {
        //   console.log('...document.mobileBs4.parsingBs4Response...ERROR', error);
        // }      
      };
    
      this.newBs4Kartoteka = (message, lastCommandParserAfterRow, toBeContinue) => {
        const dockingRegion = Bs4Kartoteka.getDockingRegion(message);

        //message._Komunikat.bs4ConstructorMode = true;
        if (dockingRegion === Bs4Kartoteka.DOCKING_REGION_NEW_TAB) {
          // New tab (window)
          message._Komunikat.bs4CardType = '1'
          // Avoids cyclic links (JSON circular) // toBeContinue.lastCommandParserAfterRow w nowym tab nie ma zastosowania.
          delete toBeContinue?.lastCommandParserAfterRow;
          window.localStorage.setItem('bs4ExternalLink', JSON.stringify({
            cardData: message,
            toBeContinue: toBeContinue,
          }));
                    
          let url = window.location.href.split("#")[0];	
          const appleBs4 = Bs4MainDispatch.getAppleBs4()
          if (appleBs4) window.open(url, '_self').focus();
          else window.open(url, '_blank').focus(); 
          return;
        }        
        
        if (dockingRegion === Bs4Kartoteka.DOCKING_REGION_RIGHT) {          
          if (!message?._IdBs4Source) message._IdBs4Source = Bs4Kartoteka.getLast()?.message?._Komunikat?.currentCardViewId;

          const rightChild = Bs4Kartoteka.getRightChild(message?._IdBs4Source);
          if (rightChild) {
            Bs4Kartoteka.remove(rightChild.bs4KartotekaId)
            .then(() => this.newBs4KartotekaOk(message, lastCommandParserAfterRow, toBeContinue))
            .catch(msg => console.log(msg))
            return;
          }
        }

        this.newBs4KartotekaOk(message, lastCommandParserAfterRow, toBeContinue);
      }

      this.newBs4KartotekaOk = (message, lastCommandParserAfterRow, toBeContinue) => {
        
        const bs4Kartoteka = new Bs4Kartoteka(message);
        bs4Kartoteka.lastCommandParserAfterRow = lastCommandParserAfterRow;
        bs4Kartoteka.toBeContinue = toBeContinue;

        if (bs4Kartoteka.isFirst()) {
          this.bs4KartotekaId = bs4Kartoteka.bs4KartotekaId;
          if (!Bs4MainDispatch.getMobile() && !Bs4MainDispatch.skipFirebaseMessaging) {
            try {
              // console.log('...FCM.FCM.FCM...');
              // import('./Bs4NotificationsFCM.js').then(module => {                
              //   module.default();
              // })
              // bs4NotificationsFCM();
            } catch (error) {
              console.log('...FCM.FCM.FCM...');
              console.log(error);              
            }
          }
          this.mainBs4Kartoteka = bs4Kartoteka;
          this.mainBs4KartotekaId = bs4Kartoteka.bs4KartotekaId;
          if (Bs4MainWindow.mainPageDetails) {
            bs4Kartoteka.bs4MenuType = 'MENU_TYPE_MAIN';
            setMainMenu(bs4Kartoteka.bs4Menu);
          }
        }
            
        bs4Kartoteka.lastCommandParserAfterRow?.select();
        this.showStack();
      }

      this.showStack = (toBeContinue) => {
        setShowStack(Bs4Kartoteka.getShowStack(smallScreen));
        setToBeContinue(toBeContinue || null);
      }

      ///////////////////////////////////////////////////////////// end      

      setShowStack(Bs4Kartoteka.getShowStack(smallScreen));
    }, [smallScreen])    

    React.useEffect(() => {
      //Wznowienie wykonywania dymków po akcji ONLY_CLOSE_WINDOW', itp...      
      Bs4MainDispatch.toBeContinueParsingBs4ResponseMessgs(toBeContinue, lastBs4Kartoteka);
    }, [toBeContinue])

    React.useEffect(() => {
      bs4LaunchMainPage();
      setUxTemplateUpdate();      
    }, [])

    if (lastBs4Kartoteka) lastBs4Kartoteka.setMiniLeftMenu();

    const Bs4Login = React.useMemo(() => {      
      if (loginMessage?.pageDetails) return Bs4LoginNew;
      // ????????????????? ///
      return Bs4LoginOld;
    }, [loginMessage?.pageDetails])
    
    
    // console.log('...ViewMain...', theme.Bs4.backgroundPicture,);

    return (
      <Box id='...ViewMain...' height='100vh' width='100vw' display='flex' flexDirection='column' sx={{backgroundColor: theme.Bs4.backgroundColor, ...theme.Bs4.backgroundPicture}}>
        <CssBaseline/>   
        <Bs4NewTab 
          link={linkNewTab} 
          onClose={() => setLinkNewTab(null)}
        />
        <Bs4Login
          loginMessage={loginMessage}
          askCodeStep2={askCodeStep2}
          setAskCodeStep2={setAskCodeStep2}
        />
        <Bs4SessionExpired        
          documentTitle={document.title}
          sessionExpired={sessionExpired}
          smallScreen={smallScreen}
        />
        <Bs4ShowRequest showBs4Request={bs4ShowRequest} setBs4ShowRequest={setBs4ShowRequest}/>
        <Bs4AppBar.instance.ViewComponent mainPageDetails={mainPageDetails} MenuIconButton={MenuIconButton}/>
        <Bs4HorizontalMenu 
          bs4KartotekaId={this.mainBs4KartotekaId} 
          targetOption={300}
          bs4Menu={mainMenu}
          bs4MenuType={mainPageDetails?._Komunikat?.bs4MenuType}
          onMenuClick={thisMain.handleMenuClick}
          addDelayedTabsData          
          setMenu={thisMain.mainBs4Kartoteka?.setCardMenu}
          setMenuIconButton={setMenuIconButton}
        />
        <Box flex={1} display='flex' flexDirection='row' overflow='hidden'>
          <Bs4VerticalMenu 
            bs4KartotekaId={this.mainBs4KartotekaId}
            targetOption={300}
            bs4Menu={mainMenu}
            bs4MenuType={mainPageDetails?._Komunikat?.bs4MenuType} 
            onMenuClick={thisMain.handleMenuClick}
            addDelayedTabsData
            setMenu={thisMain.mainBs4Kartoteka?.setCardMenu}
            setMenuIconButton={setMenuIconButton}
            miniLeftMenu={miniLeftMenu}
            variantMenuName='Menu'
          />
          <Box flex={1} position='relative'>
            {showStack.map((bs4Kartoteka, index) => {
              Bs4MainDispatch.speedRun((tag) => {
                console.log(Bs4MainDispatch.speedNextTime(tag) , Bs4MainDispatch.speedBs4KarOpt(bs4Kartoteka.bs4KartotekaId, ''))
            }, 'Main.showStack');
              return <bs4Kartoteka.ViewComponent key={bs4Kartoteka.bs4KartotekaId} smallScreen={smallScreen}/>
            })}
          </Box>
        </Box>              
      </Box>        
    );    
  }
}